/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type THealthCheckResponse = {
    /**
     * Git SHA of the running build ('dev' locally)
     */
    release: string;
    status: THealthCheckResponse.status;
};
export namespace THealthCheckResponse {
    export enum status {
        OK = 'ok',
    }
}

